export const apiURL = 'https://hub.emeraldplanet.com.au/api/';
// export const apiURL = 'http://dev.hub.emeraldplanet.com.au/api/';

export const socketURL = process.env.REACT_APP_SOCKET_URL || 'wss://erjoz0vmw1.execute-api.ap-southeast-2.amazonaws.com/dev';